(() => {
  const init = root => root.querySelectorAll('.ss-mix-form').forEach(form => {
    if (form.dataset.mixReady) return;
    form.dataset.mixReady = 'true';
    const currency = form.dataset.currency || 'USD';
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
    form.querySelectorAll('[data-mix-picker]').forEach(picker => {
      const product = picker.querySelector('[data-mix-product]');
      const variant = picker.querySelector('[data-kit-select]');
      const image = picker.querySelector('[data-mix-image]');
      const placeholder = picker.querySelector('[data-mix-placeholder]');
      const detail = picker.querySelector('[data-mix-detail]');
      const feedback = picker.querySelector('[data-mix-feedback]');
      const selection = picker.querySelector('[data-mix-selection]');
      const modelLabel = picker.querySelector('[data-mix-model-label]');
      const variantLabel = picker.querySelector('[data-mix-variant-label]');
      let controller;
      let variants = [];
      const reset = message => {
        variant.replaceChildren(new Option(message, ''));
        variant.disabled = true;
        variant.dispatchEvent(new Event('change', { bubbles: true }));
      };
      const showImage = value => {
        if (!value) return;
        const url = new URL(value, location.origin);
        if (url.protocol !== 'https:' || (url.origin !== location.origin && url.hostname !== 'cdn.shopify.com')) return;
        url.searchParams.set('width', '540');
        image.src = url.href;
        image.hidden = false;
        placeholder.hidden = true;
      };
      product.addEventListener('change', async () => {
        controller?.abort();
        picker.removeAttribute('aria-busy');
        const selected = product.value;
        variants = [];
        feedback.textContent = '';
        detail.hidden = true;
        image.hidden = true;
        placeholder.hidden = false;
        reset(selected ? form.dataset.loading : form.dataset.first);
        if (!selected) return;
        const url = new URL(selected, location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
        detail.href = url.href;
        detail.hidden = false;
        showImage(product.selectedOptions[0].dataset.image);
        image.alt = product.selectedOptions[0].textContent;
        controller = new AbortController();
        const activeController = controller;
        picker.setAttribute('aria-busy', 'true');
        feedback.textContent = form.dataset.loading;
        try {
          const endpoint = new URL(url.href);
          endpoint.pathname += '.js';
          const response = await fetch(endpoint.href, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: activeController.signal });
          if (!response.ok) throw new Error('Product unavailable');
          const data = await response.json();
          if (activeController.signal.aborted || product.value !== selected) return;
          if (!Array.isArray(data.variants)) throw new Error('Product unavailable');
          variants = data.variants.filter(item => Number.isSafeInteger(item.id) && Number.isFinite(item.price) && item.price >= 0);
          variant.replaceChildren(new Option(form.dataset.choose, ''));
          variants.forEach(item => {
            const option = new Option(`${item.title} — ${money.format(item.price / 100)} ${currency}${item.available ? '' : ' · ' + form.dataset.soldOut}`, String(item.id));
            option.dataset.price = String(item.price);
            option.disabled = !item.available;
            variant.append(option);
          });
          variant.disabled = !variants.some(item => item.available);
          feedback.textContent = variant.disabled ? form.dataset.none : '';
        } catch (error) {
          if (activeController.signal.aborted) return;
          reset(form.dataset.first);
          feedback.textContent = form.dataset.loadError;
        } finally {
          if (!activeController.signal.aborted) {
            picker.removeAttribute('aria-busy');
            variant.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
      variant.addEventListener('change', () => {
        const selected = variants.find(item => String(item.id) === variant.value);
        selection.hidden = !product.value;
        modelLabel.textContent = product.value ? product.selectedOptions[0].textContent.trim() : '';
        variantLabel.hidden = !selected;
        variantLabel.textContent = selected ? variant.selectedOptions[0].textContent : '';
        if (selected?.featured_image?.src) showImage(selected.featured_image.src);
        else if (product.value) showImage(product.selectedOptions[0].dataset.image);
        if (product.value) {
          const url = new URL(product.value, location.origin);
          if (selected) url.searchParams.set('variant', String(selected.id));
          detail.href = url.href;
        }
      });
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
